import {
  CreateProjectInput,
  UpdatePlanterProjectInput
} from 'src/config/generated/graphql'
import { ProjectWorkflowState } from 'src/types/project'

import { ProjectFormValues } from './types'

export const parseCreateProject = (
  project: ProjectFormValues,
  isDraft: boolean = false
): CreateProjectInput => {
  return {
    Area: project.Area,
    Description: project.Description || '',
    Name: project.Name,
    RegionId: project.Region,
    Geo: JSON.stringify(project.Geo),
    DistrictId: project.District,
    LandUse: project.LandUse,
    LandUseOther: project.LandUseOther,
    OtherLandArea: project.OtherLandArea,
    NumberOfProperties: project.NumberOfProperties,
    PlantingTimeframes: project.PlantingTimeframes,
    Purpose: project.Purpose,
    WebsiteLinks: project.WebsiteLinks,
    WorkflowState: isDraft
      ? ProjectWorkflowState.Draft
      : ProjectWorkflowState.Submitted
  }
}

export const parseUpdateProject = (
  projectId: string,
  project: ProjectFormValues,
  isDraft: boolean = false
): UpdatePlanterProjectInput => {
  return {
    Id: projectId,
    Area: project.Area,
    Description: project.Description || '',
    Name: project.Name,
    RegionId: project.Region,
    Geo: JSON.stringify(project.Geo),
    DistrictId: project.District,
    LandUse: project.LandUse,
    LandUseOther: project.LandUseOther,
    OtherLandArea: project.OtherLandArea,
    NumberOfProperties: project.NumberOfProperties,
    PlantingTimeframes: project.PlantingTimeframes,
    Purpose: project.Purpose,
    WebsiteLinks: project.WebsiteLinks,
    IsDraft: isDraft
  }
}
